var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4348 15.6H12.0348V14.4H11.4348V15.6ZM1 14.4H0.4V15.6H1V14.4ZM6.21732 11.087L5.79305 11.5112L6.21731 11.9355L6.64158 11.5112L6.21732 11.087ZM11.4348 14.4H1V15.6H11.4348V14.4ZM6.81732 11.087V0H5.61732V11.087H6.81732ZM1.22786 6.94595L5.79305 11.5112L6.64158 10.6627L2.0764 6.09743L1.22786 6.94595ZM6.64158 11.5112L11.2068 6.94596L10.3583 6.09743L5.79305 10.6627L6.64158 11.5112Z",
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.8c1fee9eb1f80be2463b3e8d22872906.svg";
export { ForwardRef as ReactComponent };